export enum CompensationPhase {
  Approval = "approval",
  InTransit = "in_transit",
  Delivered = "delivered",
}
